import React from 'react';
import { learningOutcomes } from '../../data/palmistry101Content';

export default function PalmistryLearningOutcomes() {
  return (
    <section className="amm-palmistry101-section" aria-labelledby="palmistry-learn-heading">
      <h2 id="palmistry-learn-heading" className="amm-palmistry101-section-title">
        What You’ll Learn in Palmistry 101
      </h2>
      <ul className="amm-palmistry101-outcomes">
        {learningOutcomes.map((line, i) => (
          <li key={i} className="amm-palmistry101-outcome-item">
            {line}
          </li>
        ))}
      </ul>
      <div className="amm-palmistry101-invitation">
        <p>
          Your hand is always with you. You don’t need a perfect moment — only one honest question and the
          willingness to look.
        </p>
      </div>
    </section>
  );
}
